import {
    Alert,
    Card,
    CardContent,
    Checkbox,
    CircularProgress,
    Container,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Stack,
    Typography,
} from '@mui/material';

import PageTitle from '../components/PageTitle';
import { GeneralLayout } from '../layouts/GeneralLayout';
import { useGetAcademicYearReadinessQuery } from '../store/system/systemApi';

export default function AcademicYearReadinessPage() {
    const { data, isLoading, isError } = useGetAcademicYearReadinessQuery();
    const readiness = data?.data;

    return (
        <GeneralLayout>
            <PageTitle title="Готовность к новому учебному году" />

            <Container maxWidth="md">
                <Stack spacing={3} pt={15} pb={5}>
                    <Typography variant="h4">
                        Готовность к новому учебному году
                    </Typography>

                    {readiness && (
                        <Typography color="text.secondary">
                            Проверка данных для {readiness.targetYearStart}/{readiness.targetYearEnd} учебного года
                        </Typography>
                    )}

                    {isLoading && (
                        <Stack alignItems="center" py={8}>
                            <CircularProgress />
                        </Stack>
                    )}

                    {isError && <Alert severity="error">Не удалось получить состояние готовности системы.</Alert>}

                    {readiness && (
                        <>
                            <Alert severity="info">
                                {readiness.isReady
                                    ? 'Система готова к запуску нового учебного года.'
                                    : 'Не все данные подготовлены. Готовые пункты отмечены флажком.'}
                            </Alert>

                            <Card>
                                <CardContent>
                                    <List disablePadding>
                                        {readiness.checks.map((check, index) => (
                                            <ListItem
                                                key={check.key}
                                                divider={index < readiness.checks.length - 1}
                                            >
                                                <ListItemIcon>
                                                    <Checkbox
                                                        edge="start"
                                                        checked={check.isReady}
                                                        color="primary"
                                                        disableRipple
                                                        inputProps={{
                                                            'aria-label': check.title,
                                                            readOnly: true,
                                                        }}
                                                    />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={`${index + 1}. ${check.title}`}
                                                    secondary={check.details}
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </CardContent>
                            </Card>
                        </>
                    )}
                </Stack>
            </Container>
        </GeneralLayout>
    );
}
